// Re-export shim: AppIcon now lives in @em/ui (injected registry). Importing this
// module configures the app's generated icon set into @em/ui as a SIDE EFFECT,
// so every AppIcon render — in the app AND in shared @em/ui components — resolves.
// Because the generic barrel re-exports this, it loads at app startup.
import { AppIcon, iconExists, getAvailableIcons, configureIcons } from "@em/ui";
import type { AppIconProps } from "@em/ui";

import { IconRegistry, FallbackIcon } from "./iconRegistry.generated";

configureIcons(IconRegistry, FallbackIcon);

export { AppIcon, iconExists, getAvailableIcons };
export type { AppIconProps };
export default AppIcon;
